import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`sign_receipt_date_from`／`_to`）。
 */
export function readSignReceiptDateRangeFilter(filters = {}) {
  const from = filters.signReceiptDateFrom;
  const to = filters.signReceiptDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applySignReceiptDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.signReceiptDateFrom;
    delete next.signReceiptDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  next.signReceiptDateFrom = from || undefined;
  next.signReceiptDateTo = to || undefined;

  return next;
}

export function resolveSignReceiptDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.signReceiptDateFrom,
    to: ctx.filters?.signReceiptDateTo,
  });

  return display ? [display] : [];
}
